"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _utils = require("../utils");

var _text = require("../text");

var _TextCSS = require("../text/TextCSS");

var _constants = require("../text/constants");

var _constants2 = require("./constants");

var LinkWithoutDocs = (0, _context.styledWithTheme)('a', {
  shouldForwardProp: (0, _utils.filterProps)([].concat((0, _toConsumableArray2.default)(_constants.textPropsToFilter), ['hasHover', 'isSelected', 'padding']))
})(function (_ref) {
  var theme = _ref.theme,
      _ref$color = _ref.color,
      colorProp = _ref$color === void 0 ? _constants2.defaultProps.color : _ref$color,
      _ref$textDecoration = _ref.textDecoration,
      textDecoration = _ref$textDecoration === void 0 ? _constants2.defaultProps.textDecoration : _ref$textDecoration,
      padding = _ref.padding,
      textProps = (0, _objectWithoutProperties2.default)(_ref, ["theme", "color", "textDecoration", "padding"]);
  var color = (0, _utils.cssProp)(theme.selectors.color, colorProp);
  var activeColor = colorProp === 'primary70' ? theme.selectors.color('primary80') : (0, _utils.darken)(color, 0.05); // If the link has text decoration, remove it on hover. Otherwise,
  // add an underline on hover.

  var hoverTextDecoration = textDecoration !== 'none' ? 'none' : 'underline'; // This has to be done using the CSS explicitly because using Text.withComponent('a')
  // leads to an issue where Link.withComponent() erases the styles inherited from Text.

  var textCSSObject = theme.shouldUseResponsiveText ? (0, _TextCSS.responsiveTextCSS)((0, _objectSpread2.default)({
    theme: theme
  }, textProps)) : (0, _TextCSS.textCSS)((0, _objectSpread2.default)({
    theme: theme
  }, textProps));
  return (0, _objectSpread2.default)({}, textCSSObject, {
    color: color,
    textDecoration: textDecoration
  }, (0, _utils.cssValuesProp)(theme.selectors.space, padding, 'padding'), {
    ':focus': {
      outline: "2px solid ".concat(color),
      outlineOffset: 2
    },
    ':hover': {
      color: color,
      textDecoration: hoverTextDecoration
    },
    ':visited': {
      color: color
    },
    // Active must come last so it overrides
    // the colours for other states
    ':active': {
      color: activeColor
    }
  });
});
var LinkWithDocs = (0, _stencilReactDesc.describe)(LinkWithoutDocs).description('Interactive navigation element used within text.');
LinkWithDocs.defaultProps = {
  color: 'primary70',
  fontWeight: 'medium',
  textDecoration: 'underline'
};
LinkWithDocs.propTypes = (0, _objectSpread2.default)({}, _text.Text.describedPropTypes, {
  href: _stencilReactDesc.PropTypes.string.description('Target location for the link to navigate to.'),
  children: _stencilReactDesc.PropTypes.node.description('Elements displayed which will be clickable.')
});
var Link = (0, _utils.withTestAttributes)({
  component: 'StencilLink'
})(LinkWithDocs);
Link.displayName = 'Link';
var _default = Link;
exports.default = _default;